import { useState, ReactNode } from 'react';
import Button from '../Button';
import { translate } from 'infras/i18n';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  mediaMaxWithLayoutTheme,
  fontWeight,
  borderRadius,
} from 'presentations/views/styles';
import {
  blue01,
  error,
  primary,
  secondary,
  white,
} from 'presentations/views/styles/color';
import Grow from '@mui/material/Grow';

export enum SeverityType {
  Error = 'error',
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
}

interface Props {
  isOpen: boolean;
  severity?: SeverityType;
  message?: string | ReactNode;
  onClose?: any;
  autoHideDuration?: number;
}
export default function Component(props: Props) {
  const [open, setOpen] = useState(props.isOpen);

  const handleClose = (
    event: Event | React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') return;
    close();
  };

  function close() {
    if (props.onClose) props.onClose();
    setOpen(false);
  }

  const severity = props.severity;
  let color = 'primary';
  switch (props.severity) {
    case 'error':
      color = 'error';
      break;
    case 'warning':
      color = 'secondary';
      break;
    default:
      break;
  }
  return (
    <StyledSnackbar
      open={open}
      autoHideDuration={props.autoHideDuration || 5000}
      TransitionComponent={Grow}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Container>
        {props.severity ? (
          <StyledAlert elevation={6} onClose={handleClose} severity={severity}>
            {props.message}
          </StyledAlert>
        ) : (
          <SnackbarContent
            message={props.message}
            action={
              <Button variant="text" color="inherit" onClick={close}>
                {translate('Close')}
              </Button>
            }
          />
        )}
      </Container>
    </StyledSnackbar>
  );
}

const StyledSnackbar = styled(Snackbar)`
  /* bottom: 80px; */
`;
const StyledAlert = styled(MuiAlert)<{ severity: string | undefined }>`
  background-color: ${white};
  color: ${(props) => {
    switch (props.severity) {
      case 'error':
        return error;
      case 'warning':
        return secondary;
      default:
        return primary;
    }
  }};
  font-weight: ${fontWeight('bold')};
  border: 1px solid ${primary};
  border-color: ${(props) => {
    switch (props.severity) {
      case 'error':
        return error;
      case 'warning':
        return secondary;
      default:
        return primary;
    }
  }};
  .MuiAlert-message {
    flex-grow: 1;
  }
  .MuiAlert-icon {
    color: ${(props) => {
      switch (props.severity) {
        case 'error':
          return error;
        case 'warning':
          return secondary;
        default:
          return primary;
      }
    }};
  }
  border-radius: ${borderRadius(6)};
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
`;

const Container = styled.div`
  min-width: 600px;
  ${(props) => mediaMaxWithLayoutTheme(props, 'tablet')} {
    min-width: 300px;
  }
`;
